import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { SharedFormWrapperUiIonFormFieldModule } from '@ts/shared/form/wrapper/ui-ion-form-field';

import { FormScaffoldUiComponent } from './form-scaffold-ui/form-scaffold-ui.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    SharedFormWrapperUiIonFormFieldModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  declarations: [FormScaffoldUiComponent],
  exports: [FormScaffoldUiComponent],
})
export class SharedFormUiFormScaffoldModule {}
